import { parseNovelAdminJobRetry, parseNovelAdminRunDetail, parseNovelAdminRunList } from '@drama/contracts/novel'

import { novelAdminHttp } from './http.js'

const QUERY_KEYS = new Set(['email', 'pack_id', 'failed_only', 'page', 'page_size'])

/**
 * @callchain.routeId novel.admin.runs.list
 * failed_only 为 'true' 时只返回有失败后台任务的对局。
 * @param {{ email?: string, pack_id?: string, failed_only?: 'true', page?: number, page_size?: number }} [query]
 */
export async function listNovelRuns(query = {}) {
  const unknown = Object.keys(query).filter((key) => !QUERY_KEYS.has(key))
  if (unknown.length > 0) throw new Error(`listNovelRuns: unknown query keys ${unknown.join(', ')}`)
  const response = await novelAdminHttp().get('/runs', { query, routeId: 'novel.admin.runs.list' })
  return parseNovelAdminRunList(response)
}

/**
 * @callchain.routeId novel.admin.runs.detail
 * @param {string} runId
 */
export async function getNovelRun(runId) {
  const response = await novelAdminHttp().get(`/runs/${encodeURIComponent(runId)}`, { routeId: 'novel.admin.runs.detail' })
  return parseNovelAdminRunDetail(response)
}

/**
 * @callchain.routeId novel.admin.runs.retryJob
 * @param {string} runId
 * @param {string} jobId
 */
export async function retryNovelJob(runId, jobId) {
  const response = await novelAdminHttp().post(`/runs/${encodeURIComponent(runId)}/jobs/${encodeURIComponent(jobId)}/retry`, {
    body: {},
    routeId: 'novel.admin.runs.retryJob',
  })
  return parseNovelAdminJobRetry(response)
}
